import type { SxProps } from '@mui/material'
import { ListItemIcon as MUIListItemIcon } from '@mui/material'
import { Icon } from '@/CommonComponents'
import type { IAvailableIcons } from './Icon'
interface IListItemIconProps {
  icon: IAvailableIcons
  sx?: SxProps
}
export default function ListItemIcon({ icon, sx }: IListItemIconProps) {
  return (
    <MUIListItemIcon sx={sx}>
      <Icon icon={icon} />
    </MUIListItemIcon>
  )
}
